import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FailEmailList',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const tableData = ref([]);

const show = (list: any[]) => {
  // If the list is just strings (emails), map to object.
  // If it's objects, usage depends on structure.
  // Assuming list of strings based on typical "failedEmailList" naming,
  // but if it has reasons it might be objects.
  // Let's handle both simple strings and objects if possible, but for now assuming strings or simple objects.
  // Ref: User said "failedEmailList", likely just emails or simple objects.
  // Let's assume generic display for now.

  if (list && list.length > 0 && typeof list[0] === "string") {
    tableData.value = list.map((email) => ({ email: email, reason: "" }));
  } else {
    tableData.value = list || [];
  }

  visible.value = true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "Failed Email List",
    width: "50%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Close")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"},
        height: "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "email",
            label: "Email"
          }),
          _createVNode(_component_el_table_column, {
            prop: "reason",
            label: "Reason"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})